import { create } from 'zustand';

export type VoiceHighlightState = {
  /** Curated help target id, or null for callout-only (guide speak_next). */
  target: string | null;
  title?: string;
  body?: string;
  durationMs: number;
  startedAt: number;
  /** When true, overlay shows a Continue control for speak_next / either. */
  showContinue?: boolean;
} | null;

type VoiceHighlightStore = {
  highlight: VoiceHighlightState;
  setHighlight: (next: Exclude<VoiceHighlightState, null>) => void;
  clearHighlight: () => void;
};

export const useVoiceHighlightStore = create<VoiceHighlightStore>((set) => ({
  highlight: null,
  setHighlight: (next) => set({ highlight: next }),
  clearHighlight: () => set({ highlight: null }),
}));
